
import React, { useState, useEffect } from 'react';
import Wrapper from './styles';
import { PageHero, StripeCheckout, ShippingForm, Loading } from '../../components';
import { checkObjectProperties } from '../../utils/helpers';
import { useCartContext } from '../../context/cart_context';
import { useOrderContext } from '../../context/order_context';
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useUserContext } from '../../context/user_context';
import { formatPrice } from '../../utils/helpers';

const CheckoutPage = () => {
  const {
    shipping: {
      name,
      address: { line1, postal_code, city, state, country },
    },
    paymentMethod,
    placeOrder
  } = useOrderContext();
  const {email}=useUserContext()
  const { cart, total_amount,clearCart, couponDiscount} = useCartContext();
  const [editingShipping, setEditingShipping] = useState(true);
  const [isLoading, setIsLoading]=useState(false)
  const history = useHistory();
 let taxPrice = 0;
  cart.map((e) => (taxPrice += (e.price * e.amount * e.taxPrice) / 10000));
  const confirmShipping = async() => {
     if (paymentMethod === 'COD') {
      let paidAmount = Math.floor(total_amount) - Number(couponDiscount);
      setIsLoading(true)
       const amount = total_amount;
       const currency = 'INR';
       const receiptId = '1234567890';
       const response = await fetch(
         `${process.env.REACT_APP_BACKEND_HOST}/order`,
         {
           method: 'POST',
           headers: {
             'Content-Type': 'application/json',
           },
           body: JSON.stringify({
             amount:Math.round(paidAmount),
             currency,
             receipt: receiptId,
           }),
         }
       );

       const order = await response.json();
       let res = await placeOrder(paymentMethod);

       toast.success(order);
       setTimeout(() => {
         clearCart();
         setIsLoading(false);
         history.push('/orders');
       }, 5000);
     }
    if(paymentMethod!=="COD"){
        setEditingShipping(false);
    }
   
  };

  useEffect(() => {
    if (
      checkObjectProperties({ name, line1, postal_code, city, state, country })
    ) {
      return setEditingShipping(true);
    }
    // setEditingShipping(false);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    document.title = 'Mukunda jewelery | Checkout';
  }, []);

  const handleCancel = () => {
    setEditingShipping(true);
  };

 

  return (
    <main>
      <PageHero title='checkout' />

      {!isLoading ? (
        editingShipping ? (
          <ShippingForm confirmShipping={confirmShipping} />
        ) : (
          <Wrapper className='page'>
            {cart.length < 1 ? (
              <div className='empty'>
                <h2>Your cart is empty</h2>
                <Link to='/collections' className='btn'>
                  fill it
                </Link>
              </div>
            ) : (
              <StripeCheckout onCancel={handleCancel} />
            )}
          </Wrapper>
        )
      ) : (
        <Loading />
      )}
    </main>
  );
};

export default CheckoutPage;